import type { IconButtonProps } from '@mui/material/IconButton';

import IconButton from '@mui/material/IconButton';

import { Iconify } from '@components/Iconify';

// ----------------------------------------------------------------------

export function MenuButton({ sx, ...other }: IconButtonProps) {
  return (
    <IconButton sx={sx} aria-label="Open menu" {...other}>
      <Iconify icon="custom:menu-duotone" width={24} />
    </IconButton>
  );
}
